<template>
  <div class="diseaseList">
    <!-- 开户按钮 -->
    <el-form :inline="true"  size="small">
      <el-form-item>
        <el-button
          :loading="downloadLoading"
          style="margin-right: 20px"
          type="primary"
          icon="el-icon-document"
          @click="handleDownload"
          >导出 Excel（数量/ {{ dataList.length }}条）</el-button
        >
      </el-form-item>
    </el-form>
    <!-- 商品表格 -->
    <div style="height: 80vh">
      <el-table
        :data="dataList"
        style="width: 100%"
        height="100%"
        border
        v-loading="loading"
        element-loading-spinner="el-icon-loading"
        element-loading-text="正在加载中"
      >
        <el-table-column
          type="index"
          label="序号"
          width="50"
          align="center"
        ></el-table-column>
        <el-table-column
          label="登记时间"
          width="200"
          align="center"
          prop="createTime"
          sortable
        ></el-table-column>
        <el-table-column label="姓名" width="100" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.name }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="年龄"
          width="60"
          align="center"
          prop="age"
        ></el-table-column>
        <el-table-column
          label="邮箱"
          align="center"
          prop="email"
        ></el-table-column>
        <el-table-column
          label="手机号"
          width="150"
          align="center"
          prop="phone"
        ></el-table-column>

        <el-table-column label="种类" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.resource }}</span>
          </template>
        </el-table-column>
        <el-table-column label="是否加急联系" align="center" width="110">
          <template slot-scope="scope">
            <span>{{ scope.row.delivery ? "加急" : "不加急" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="数据来源" align="center" width="80">
          <template slot-scope="scope">
            <span>{{ scope.row.equipment == 0 ? "电脑端" : "手机端" }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="留言"
          align="center"
          prop="message"
        ></el-table-column>
        <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <el-button size="mini" type="danger" @click="deleteBtn(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import {
  selectPtRegister,
  deletePtRegister,
} from "@/services/supAdmin/teaData/index.js";
// import { createCardnumberList, selectCardnumberList } from "@/services/vipCard";
export default {
  data() {
    return {
      downloadLoading: false,
      dataList: [],
      supplierPhone: "",
      phone: "",
      cardNumber: "",
      loading: false,
      name: "",
      pageCount: "",
      pageSize: 8,
      adminArr: [
        { name: "最高权限", id: 1 },
        { name: "普通子账号权限", id: 2 },
      ],
      form: {},
      dialogFormVisible: false,
    };
  },
  created() {
    this.select();
  },
  methods: {
    select() {
      // 查询数据
      this.loading = true;
      selectPtRegister().then((res) => {
        console.log(res);
        this.dataList = res.data;
        this.loading = false;
      });
    },
    // 删除
    deleteBtn(row) {
      console.log("----------删除------------", row);
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          console.log("删除成功");

          deletePtRegister(row.id).then((res) => {
            console.log(res);
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            this.select();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
      // this.$message.error('暂未开启该权限')
      // this.select();
    },

    // 导出数据
    handleDownload() {
      this.downloadLoading = true;
      import("@/utils/vendor/Export2Excel").then((excel) => {
        const tHeader = [
          "时间",
          "姓名",
          "手机号",
          "公司",
          "职位",
          "城市",
          "目的",
          "留言",
          "设备",
        ];
        const filterVal = [
          "createTime",
          "name",
          "phone",
          "fair",
          "position",
          "city",
          "intention",
          "remarks",
          "equipment",
        ];
        const list = this.dataList;
        const data = this.formatJson(filterVal, list);
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: "兼职登记数据下载",
          autoWidth: true, //Optional
          bookType: "xlsx", //Optional
        });
        setTimeout(() => {
          this.downloadLoading = false;
        }, 2000);
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) =>
        filterVal.map((j) => {
          return v[j];
        })
      );
    },
  },
};
</script>

<style>
.content {
  margin: 30px auto;
  /* border:1px solid red; */
  width: 80%;
}
.el-pagination {
  text-align: center;
  margin: 20px;
}
.userNanme:hover {
  cursor: pointer;
}
</style>